import React, { useState, useEffect, useRef } from 'react';
import './PriceUpdate.scss';

const PriceUpdate = ({ 
  oldRate, 
  newRate,
  oldAmount, 
  newAmount,
  isMobileView,
  isRateAndAmountCase
}) => {
  const [showOffer, setShowOffer] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        // Trigger the animation when the component scrolls into view
        if (entry.isIntersecting) {
          setShowOffer(true);
          
          // Stop observing once the animation has been triggered
          if (containerRef.current) {
            observer.unobserve(containerRef.current);
          }
        }
      },
      { threshold: 0.5 } // Triggers when 50% of the element is visible
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    // Cleanup observer on component unmount
    return () => {
      if (containerRef.current) {
        observer.unobserve(containerRef.current);
      }
    };
  }, []);

  return (
    <div className={`price-widget-wrapper ${isRateAndAmountCase ? 'rate-and-amount-case' : ''} ${isMobileView ? 'mobile-view' : ''}`} ref={containerRef}>
      <div className={`price-container ${showOffer ? 'updated' : ''}`}>
        
        {/* --- Old Price Container --- */}
        <div className="old-price">
          <span className="strike-line"></span>
          
          {oldRate && <span className="rate-text">{oldRate}</span>}
          {oldRate && <span className="separator-hyphen">&nbsp;-&nbsp;</span>}
          <span className="amount-text">{oldAmount}</span>
        </div>

        {/* --- New Price Container --- */}
        <div className="new-price">
          
          {newRate && <span className="rate-text">{newRate}</span>}
          {newRate && <span className="separator-hyphen">&nbsp;-&nbsp;</span>}
          <span className="amount-text">{newAmount}</span>
        </div>

      </div>
    </div>
  );
};

export default PriceUpdate;